import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Config } from '../config/config';
import { UserAccessLevel } from '../models/user.model';
import { Observable } from 'rxjs';
import { UserInfoObservable } from './observable.service';
export interface UserInfo {
    userId: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    role?: string;
    team?: string;
    organization?: string;
    subscriptionTier: 't0'|'t1'|'t2'|'t3'|'t4'; 
    avatar?: string;
    credits?: number;
    initialCredits?: number;
    doNotShowTemplateBuilderTooltip?: boolean;
    accessLevel?: UserAccessLevel;
}

@Injectable({
    providedIn: 'root',
})
export class UserService {
    apiUrl = Config.backend_url + '/users';
    constructor(
        private http: HttpClient,
        private userInfoObservable: UserInfoObservable,
    ) {
        try {
            this.getUser().subscribe();
        } catch (error) {}
        
        this.userInfoObservable.updates().subscribe((userInfo: UserInfo) => {
            if (!userInfo || Object.keys(userInfo).length === 0) {
                this._userInfo = {} as UserInfo;
            }
        });
    }
    
    _userInfo: UserInfo = {} as UserInfo;


    set userInfo(userInfo: UserInfo) {
        this._userInfo = userInfo;
    }

    get userInfo(): UserInfo {
        return this._userInfo;
    }

    createUser(data: any) {
        return this.http.post(`${this.apiUrl}/register`, data);
    }

    loginUser(){
        return this.http.post(`${this.apiUrl}/login`, {});
    }

    updateUser(data:any){
        return this.http.patch(this.apiUrl, data);
    }

    updateMapping(data:any){
        return this.http.patch(`${this.apiUrl}/mapping`, data);
    }

    getUser(): Observable<UserInfo> {
        return new Observable<UserInfo>((observer) => {
            if (this.userInfo.userId) {
                observer.next(this.userInfo);
                observer.complete();
            } else {
                this.http.get<UserInfo>(`${this.apiUrl}/info`).subscribe((userInfo: UserInfo) => {
                    this.userInfo = userInfo;
                    this.userInfoObservable.registerNewUpdate(userInfo);
                    observer.next(userInfo);
                    observer.complete();
                });
            }
        });
    }

    getProfile() {
        return this.http.get(`${Config.backend_url}/profile`);
    }

    googleIntegration(){
        return this.http.post(`${this.apiUrl}/integration`, {});
    }

    getUserAvatar(): Observable<string> {
        return this.http.get<string>(`${this.apiUrl}/avatar`);
    }
    
    uploadAvatar(file: File): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'multipart/form-data');
        headers = headers.append('Accept', '*/*');
        return this.http.post(`${this.apiUrl}/avatar`, file)
    }

    clearUserData(): void {
        this._userInfo = {} as UserInfo;
    }
}